export const projectListRoute = {
  path: "/project",
  name: "project-list",
  component: () => import("../ui/project/project-list.vue")
};
export const projectEditorRoute = {
  path: "/project/:id(\\d+)",
  name: "project-editor",
  component: () => import("../ui/project/project-editor.vue")
};
export const projectCreatorRoute = {
  path: "/project/create",
  name: "project-creator",
  component: () => import("../ui/project/project-editor.vue")
};